import { render, staticRenderFns } from "./chip-date.vue?vue&type=template&id=862999c0"
import script from "./chip-date.vue?vue&type=script&lang=js"
export * from "./chip-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports